import apiClient from './client';

export interface CreateFamilyLinkPayload {
  guardian_id: string;
  athlete_id: string;
  relationship_type?: string;
}

export interface InviteSubUserPayload {
  athlete_id: string;
  regenerate?: boolean;
}

export interface InviteTokenResponse {
  token: string;
  url: string;
  expires_at: string;
  athlete_id: string;
  athlete_name: string;
}

export interface InviteLookupResponse {
  athlete_id: string;
  athlete_first_name: string;
  athlete_last_name: string;
  athlete_dob: string | null;
  guardian_name: string;
  expires_at: string;
}

export const familiesApi = {
  createLink: (data: CreateFamilyLinkPayload) =>
    apiClient.post('/families/', data).then((r) => r.data),

  getDependents: (guardianId: string) =>
    apiClient.get(`/families/dependents/${guardianId}`).then((r) => r.data),

  getGuardians: (athleteId: string) =>
    apiClient.get(`/families/guardians/${athleteId}`).then((r) => r.data),

  deleteLink: (linkId: string) =>
    apiClient.delete(`/families/${linkId}`),

  inviteSubUser: (data: InviteSubUserPayload): Promise<InviteTokenResponse> =>
    apiClient.post('/families/invite-sub-user', data).then((r) => r.data),

  lookupInvite: (token: string): Promise<InviteLookupResponse> =>
    apiClient.get(`/families/invite/${token}`).then((r) => r.data),
};
